// extracted by mini-css-extract-plugin
export default {"modalOverlay":"VG-z","modalContent":"WG-z","header":"XG-z","close":"YG-z"};